<div class="loader-back" *ngIf="show">
    <div style="position: absolute; top: 50%; left: 50%; background-color: #fff6" class="spinner-border" role="status">
    </div>
</div>